import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"



export default React.createClass({
  displayName: "photo-id-anti-spoofing-and-anti-tampering",

  getInitialState: function() {
    return {
      scrollToElement: scrollToElement
    };
    var scrollToElement = initDeepLinkData(this.props);
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container server_integration">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="overview">FaceTec Server SDK Overview</h2>
                  <p>Learn the basics about the FaceTec Server SDKs.</p>
                </div>
                <hr/>
              </section>

              <section>
                <h3 id="standard">Standard Server and Server Dashboard</h3>
                <p>The <strong>FaceTec Standard Server SDK</strong> and <strong>FaceTec Server Dashboard</strong> are the recommended approach for new development, and provide a prescriptive, "fully managed" approach to deployment.  Both packages require zero code to configure and deploy, both are closed-source, and both are controlled via a single YAML config file.</p>
                <p>Once deployed, <strong>Standard Server</strong> is used vai REST using the <Link to="standard-server-rest-api">Standard Server REST API</Link>.</p>
                <p>The <strong>Server Dashboard</strong> is then used to view, monitor, and analyze your results in your own, secure, private environment.  See the <Link to="/server-dashboard-demo">Dashboard Demo Page</Link> to check out the Usage you have so far in Development Mode.</p>
                <hr />
              </section>

              <section>
                <h3 id="custom">Custom Server SDKs</h3>
                <p>If you need additional customization or features not provided by FaceTec Standard Server, you will need to download, run, and customize one of the Custom Server SDKs to fit your needs.</p>
                <p>The <strong>REST Sample Code</strong> package provides open-source Sample Code that you can download and customize based on your specific requirements and use cases.  The REST Sample Code relies on the Server Core SDK for core operations.</p>
                <p>The <strong>Custom Dockerized SDK</strong> wraps the REST Sample Code and Server Core SDK in an application and provides a Dockerfile and additional configuration files to make initial development, testing, and deployment easy.</p>
                <hr />
              </section>

              <section>
                <h3 id="core">Server Core SDK</h3>
                <p>All Server SDKs, Standard and Custom, use the Server Core SDK for core functionality.  The Server Core SDK is a Java JAR, and can be integrated into any Java Application for ultimate flexibility.</p>
                <blockquote><p><strong>Warning</strong>:  Usage of the Server Core SDK directly in a custom Java Application is heavily discouraged except for large organizations with special security/customization requirements and significant available resources to customize implementations, keep <Link to="/updating">Up-to-Date with SDK Versions</Link>, and can stay current with <Link to="/security-best-practices">Security Best Practices</Link>.</p></blockquote>
                <hr />
              </section>

              <section>
                <h3 id="data-and-storage">Standard Server vs. Custom Server SDKs</h3>
                <p>Please see the <Link to="/zoom-configuration-options?link=standard-vs-custom">Standard Server vs. Custom Server</Link> comparison matrix for more information.</p>
                <hr />
              </section>

              

              

              <SDKSidebar menuType="main" title="Photo ID Anti-Spoofing"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/server-sdk-overview.jsx